import { useState } from 'react';
import LoadingModal from '../../Layout/LoadingModal.js';
import IntVerFixedScales from './IntVerFixedScales.js';

const IntVer = () => {

  const [activeSection, setActiveSection] = useState(0);

  return (
    <>
      <LoadingModal/>
      <div className="d-flex flex-column overflow-auto">
        <div className="d-flex mt-3">
          <div className="d-flex">
            {['Balanzas'].map((item, itemIdx) => 
              <div 
                key={itemIdx} 
                className={"text-center p-2 " + (activeSection === itemIdx ? "bg-lb-white-selected" : "cursor-pointer bg-lb-white")}
                onClick={() => setActiveSection(itemIdx)}
              >
                {item}
              </div>
            )}
          </div>
        </div>
        {activeSection === 0 ? <IntVerFixedScales/> : null}
      </div>
    </>
  )
}

export default IntVer;